import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { api, ApiError, type UserTypeRow } from '../../api';

export function NewPerson() {
  const navigate = useNavigate();
  const [types, setTypes] = useState<UserTypeRow[]>([]);
  const [form, setForm] = useState({ login: '', firstName: '', lastName: '', email: '', phone: '', userTypeId: '' });
  const [error, setError] = useState<string | null>(null);
  const [detail, setDetail] = useState<string[]>([]);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get<{ types: UserTypeRow[] }>('/admin/users/types').then((r) => {
      setTypes(r.types);
      const dflt = r.types.find((t) => t.isDefault && t.assignable) ?? r.types.find((t) => t.assignable);
      if (dflt) setForm((f) => ({ ...f, userTypeId: String(dflt.id) }));
    }).catch(() => {});
  }, []);

  const set = (k: string, v: string) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true); setError(null); setDetail([]);
    try {
      const res = await api.post<{ user: { id: number } }>('/admin/users', {
        login: form.login.trim(),
        firstName: form.firstName.trim(),
        lastName: form.lastName.trim(),
        email: form.email.trim() || undefined,
        phone: form.phone.trim() || undefined,
        userTypeId: Number(form.userTypeId),
      });
      navigate(`/admin/people/${res.user.id}`);
    } catch (err) {
      const e2 = err as ApiError;
      setError(e2.message);
      setDetail(e2.body?.detail ?? []);
    } finally { setBusy(false); }
  };

  return (
    <>
      <nav className="crumbs"><Link to="/admin/people">People</Link> <span aria-hidden>›</span> New</nav>
      <h1 className="h1">Add someone</h1>

      <form className="panel form" onSubmit={submit}>
        <label><span>First name</span>
          <input value={form.firstName} onChange={(e) => set('firstName', e.target.value)} required autoFocus /></label>
        <label><span>Last name</span>
          <input value={form.lastName} onChange={(e) => set('lastName', e.target.value)} /></label>
        <label><span>Username</span>
          <input value={form.login} onChange={(e) => set('login', e.target.value)} required minLength={2}
            autoComplete="off" /></label>
        <label><span>Email</span>
          <input type="email" value={form.email} onChange={(e) => set('email', e.target.value)} /></label>
        <label><span>Phone (for WhatsApp)</span>
          <input value={form.phone} placeholder="+6281234567890"
            onChange={(e) => set('phone', e.target.value)} /></label>
        <label><span>User type</span>
          <select value={form.userTypeId} onChange={(e) => set('userTypeId', e.target.value)} required>
            {types.map((t) => (
              <option key={t.id} value={t.id} disabled={!t.assignable}>
                {t.name}{!t.assignable ? ' — beyond your own permissions' : ''}
              </option>
            ))}
          </select></label>
        <p className="muted small">
          No password is created here, so nobody else ever knows it. Once the account exists,
          send them a link from Passwords to choose their own — or they can use
          "I have forgotten my password" on the sign-in page.
        </p>

        {error && <p className="auth__error">{error}{detail.length > 0 && <><br />{detail.join('; ')}</>}</p>}

        <div className="row">
          <button className="btn btn--primary" disabled={busy}>{busy ? 'Adding…' : 'Add'}</button>
          <Link className="btn btn--ghost" to="/admin/people">Cancel</Link>
        </div>
      </form>
    </>
  );
}
